import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Mainland from './pages/Mainland';
import FreeZone from './pages/FreeZone';
import Offshore from './pages/Offshore';
import Contact from './pages/Contact';
import IndiaUAETrade from './pages/IndiaUAETrade';
import IndiaUAEPrograms from './pages/IndiaUAEPrograms';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="pt-32">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/mainland" element={<Mainland />} />
            <Route path="/freezone" element={<FreeZone />} />
            <Route path="/offshore" element={<Offshore />} />
            <Route path="/india-uae-trade" element={<IndiaUAETrade />} />
            <Route path="/india-uae-programs" element={<IndiaUAEPrograms />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;